/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/** "Project" -> "Projects", "Amenity" -> "Amenities": the v2 list page title. */
export default function pluralTitle(title) {
  if (!title) return title;
  if (/[^aeiou]y$/i.test(title)) return `${title.slice(0, -1)}ies`;
  if (/(s|x|ch|sh)$/i.test(title)) return `${title}es`;
  return `${title}s`;
}
